import { render, staticRenderFns } from "./v-chat-bubble-file.vue?vue&type=template&id=df0c1242&scoped=true&"
var script = {}
import style0 from "./v-chat-bubble-file.vue?vue&type=style&index=0&id=df0c1242&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0c1242",
  null
  
)

export default component.exports